// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let WizardMlsTimingFields = require("../wizard/WizardMlsTimingFields.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let PropertyWizardRelayMLSTiming_draft_graphql = require("../../../__generated__/PropertyWizardRelayMLSTiming_draft_graphql.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardRelayMLSTiming_formState_graphql = require("../../../__generated__/PropertyWizardRelayMLSTiming_formState_graphql.bs.js");

let convertFragment = PropertyWizardRelayMLSTiming_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayMLSTiming_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayMLSTiming_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment_mlsListingTypeV5_decode = PropertyWizardRelayMLSTiming_draft_graphql.Utils.mlsListingTypeV5_decode;

let DraftFragment_mlsListingTypeV5_fromString = PropertyWizardRelayMLSTiming_draft_graphql.Utils.mlsListingTypeV5_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayMLSTiming_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardRelayMLSTiming_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardRelayMLSTiming_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__MLSTiming(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = draft.draftProperty;
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayMLSTiming_formState_graphql.node, convertFragment$1, props.formState);
  let stepHasBeenTouched = formState.stepMlsTimingTouched;
  let comingSoonEnabled = draft.chapterPreferenceMlsComingSoonActivated;
  let willShow = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.willShow = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.willShow, PropertyWizardFormRelay__Validators__MLSTiming.WillShow.useIsValid());
  let willAcceptOffers = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.willAcceptOffers = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.willAcceptOffers, PropertyWizardFormRelay__Validators__MLSTiming.WillAcceptOffers.useIsValid());
  let onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let tmp;
  if (onMlsAtValid !== undefined) {
    if (typeof onMlsAtValid === "object") {
      let e = onMlsAtValid.VAL;
      tmp = {
        NAME: "Error",
        VAL: e === "required" ? "is required" : (
            e === "alreadyOnMlsAndAfterToday" ? "must be before today when the property is already on MLS" : "must be after today"
          )
      };
    } else {
      tmp = "Valid";
    }
  } else {
    tmp = undefined;
  }
  let onMlsAt = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.onMlsAt = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.onMlsAt, tmp);
  let mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let tmp$1;
  if (mlsListingTypeValid !== undefined) {
    if (typeof mlsListingTypeValid === "object") {
      let e$1 = mlsListingTypeValid.VAL;
      tmp$1 = {
        NAME: "Error",
        VAL: e$1 === "alreadyOnMlsAndNotActive" ? "property is already on the MLS and therefore must be set as Active on MLS" : (
            e$1 === "required" ? "is required" : "property is already on the MLS. You must either not change this, or set it to Active on MLS"
          )
      };
    } else {
      tmp$1 = "Valid";
    }
  } else {
    tmp$1 = undefined;
  }
  let mlsListingType = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.mlsListingType = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.mlsListingType, tmp$1);
  let today = CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone));
  let match$1 = formState.mlsStatus;
  let tmp$2;
  switch (match$1) {
    case "OnMls" :
    case "OnMlsButAllowed" :
      tmp$2 = undefined;
      break;
    default:
      let tmp$3 = match.mode;
      if (typeof tmp$3 !== "object") {
        tmp$2 = Primitive_option.some(today);
      } else {
        switch (tmp$3.TAG) {
          case "Edit" :
          case "Rebroadcast" :
            tmp$2 = undefined;
            break;
          case "BroadcastQuietSeller" :
            tmp$2 = Primitive_option.some(today);
            break;
        }
      }
  }
  let match$2 = formState.mlsStatus;
  let tmp$4;
  switch (match$2) {
    case "OnMls" :
    case "OnMlsButAllowed" :
      tmp$4 = Primitive_option.some(today);
      break;
    default:
      tmp$4 = undefined;
  }
  return JsxRuntime.jsx(WizardMlsTimingFields.make, {
    tipbox: JsxRuntime.jsx(TipBoxes.PropertyWizard.MlsTimingWithComingSoon.make, {
      offMlsConfigurable: true
    }),
    questionLabel: "Are you putting the property on the MLS in the next month?",
    comingSoonEnabled: comingSoonEnabled,
    activeLabel: "Yes, I'm adding to the MLS as Active (won't be added to MLS as Coming Soon)",
    comingSoonLabel: "Yes, I'm adding to the MLS as a Coming Soon",
    offMlsLabel: "No, I have no MLS plans in the next month",
    mlsListingType: mlsListingType,
    onMlsAt: onMlsAt,
    minDate: tmp$2,
    maxDate: tmp$4,
    willShow: willShow,
    willAcceptOffers: willAcceptOffers,
    showAvailabilityToggles: draftProperty.propertyType === "FOR_SALE"
  });
}

let Validators;

let FormControl;

let TipBoxes$1;

let make = PropertyWizardRelay__MLSTiming;

exports.Validators = Validators;
exports.FormControl = FormControl;
exports.TipBoxes = TipBoxes$1;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* TipBoxes Not a pure module */
